/* 陸遜傳・第 1 章：部伍東三郡（約建安二十二年，217）
 * 史實：《陸遜傳》「丹楊賊帥費棧受曹公印綬，扇動山越，為作內應，權遣遜討棧。棧支黨多而往兵少，遜乃益施牙幢，分佈鼓角，
 *       夜潛山谷間，鼓噪而前，應時破散。遂部伍東三郡，強者為兵，羸者補戶，得精卒數萬人，宿惡蕩除，所過肅清，還屯蕪湖。」
 * 流程：1. 夜潛山谷間：山谷兩側的高點插牙幢（四處）、布鼓角（兩處），不被巡山的賊看到（被看到警覺就漲，滿了戰敗）。
 *       2. 鼓噪而前：回谷口擂鼓。插了越多旗鼓，看到的山越越多潰散；剩下的與費棧死戰。
 *       3. 強者為兵，羸者補戶：俘獲的山越人走近就跟著走；帶回營裡的編成兵、帶到村裡的補成民戶。全部安置好即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, rout, troop } from '../kit.ts';
import { MEN, SHANYUE, WU, band, night, drawBanner, drawDrum } from './luxun_kit.ts';
import { CAMP, ZHAI, VILLAGE, MOUTH, SPOTS } from '../maps/luxun_shanyue.ts';

const LV = 6, DRUMS = [1, 4], STRONG = 7, WEAK = 5, SEEN = 25, SEE_R = 380; // 被看到時每秒漲的警覺、看得到的距離（夜裡）
const YUE = { spec: SHANYUE, name: '山越' };
const LEAN = troop('lx-lean', '山越羸弱', { armor: '#9a9080', sleeve: '#7a7266', cloth: '#7a7266', plume: '#b0a890', metal: '#8a8478' }); // 羸弱：沒有甲，灰布衣

export default {
  id: 'luxun-1', map: 'luxun_shanyue', hero: 'luxun',
  title: '第 1 章　部伍東三郡', year: '建安年間（約 217）',
  brief: {
    quote: [{ text: '遜乃益施牙幢，分佈鼓角，夜潛山谷間，鼓噪而前，應時破散。', src: '《三國志·吳書·陸遜傳》' }],
    text: '丹楊賊帥費棧接受曹操的印綬，煽動山越作亂。孫權派陸遜去討伐，可是費棧的黨羽多、陸遜帶的兵少。',
    goals: ['夜裡在山谷兩側插牙幢、布鼓角，不要被巡山的賊看到', '回谷口擂鼓，鼓噪而前', '強者為兵，羸者補戶'],
  },
  words: { ally: '部曲', foe: '山越' },
  stars: [
    { text: '六處旗鼓都設好才擂鼓', ok: (m) => m.vars.planted === 6 },
    { text: '巡山的賊沒有起疑（警覺不到一半）', ok: (m) => m.vars.alertMax < 50 },
    { text: '強者為兵，羸者補戶：沒有放錯', ok: (m) => m.vars.wrong === 0 },
  ],
  steps: [
    { // 0. 夜潛山谷間
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 250; me.y = CAMP[1];
        V.night = true; V.alert = 0; V.alertMax = 0; V.planted = 0; V.wrong = 0;
        V.spots = SPOTS.map(([x, y], i) => m.folk(x, y, { still: true, near: 1, name: '', up: false, drum: DRUMS.includes(i), draw: DRUMS.includes(i) ? drawDrum : drawBanner }));
        // 巡山的賊：谷底兩隊，南北山徑各一個哨
        V.watch = [];
        for (const [x0, x1, y] of [[2600, 6600, 2300], [6600, 2600, 2320]]) for (let i = 0; i < 3; i++) {
          const u = m.foe('huangjin', x0 + i * 40, y + (i - 1) * 50, YUE); m.patrol(u, [[x0, y], [x1, y]]); V.watch.push(u);
        }
        // 山徑上的哨：站在原地左右張望，只看得到面向的那一邊（趁他轉頭時從背後過去）
        for (const y of [1235, 3365]) { const u = m.foe('huangjin', 5200, y, Object.assign({ hp: 300, maxHp: 300 }, YUE, { name: '山越哨' })); u.sentry = 0; V.watch.push(u); }
        // 山寨：睡著的賊眾、費棧
        V.zhai = [];
        for (let i = 0; i < 16; i++) { const a = (i / 16) * Math.PI * 2, d = 160 + (i % 3) * 120, u = m.foe('huangjin', ZHAI[0] + Math.cos(a) * d, ZHAI[1] + Math.sin(a) * d * 0.6, YUE); u.asleep = true; V.zhai.push(u); }
        V.fz = boss(w, MEN.feizhan, ZHAI[0] + 120, ZHAI[1], { name: '費棧', hp: 2200, atk: 36, armor: 5, ms: 240 });
        V.fz.asleep = true;
        V.guard = Array.from({ length: 3 }, (_, i) => { const u = m.foe('bandit', ZHAI[0] + 60 + (i % 2) * 120, ZHAI[1] - 120 + Math.floor(i / 2) * 240, Object.assign({}, YUE, { name: '費棧親兵', hp: 600, maxHp: 600 })); u.asleep = true; return u; });
        m.card('孫權為將軍，遜年二十一，始仕幕府。出為海昌屯田都尉，縣連年亢旱，遜開倉谷以振貧民。會稽山賊大帥潘臨，歷年不禽，遜以手下召兵，討治深險，所向皆服，部曲已有二千餘人。', '《陸遜傳》（書生篇）');
        m.after(7, () => m.card('丹楊賊帥費棧受曹公印綬，扇動山越，為作內應。棧支黨多而往兵少。', '《陸遜傳》'));
        m.after(10, () => m.line('陸遜', '賊眾我寡，不可力戰。趁夜在兩邊山上多插旗幟、分佈鼓角，教賊以為大軍已到。'));
        m.after(15, () => m.line('提示', '站在高點上不動就會插好旗、布好鼓。谷底有巡山的賊，被看到就會起疑；插好之後回谷口擂鼓。'));
        m.obj('flags', '在山谷兩側插牙幢、布鼓角', 6);
        m.obj('alert', '');
        SPOTS.forEach(([x, y], i) => m.mark('s' + i, x, y, DRUMS.includes(i) ? '鼓角' : '牙幢', true));
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.spots.forEach((f, i) => {
          if (f.up) return;
          m.chanAt(me, 's' + i, f.x, f.y, 150, 2, f.drum ? '布鼓角' : '插牙幢', () => { f.up = true; V.planted++; m.unmark('s' + i); m.prog('flags', V.planted); });
        });
        // 被巡山的賊看到：警覺上升；巡山的賊少了一個，其他人也會起疑
        for (const u of V.watch) if (u.alive && u.sentry != null) { u.sentry -= dt; if (u.sentry <= 0) { u.sentry = 3.5; u.f = -(u.f || 1); } u.look = u.f; }
        const seen = me.vis[1] && V.watch.some((u) => u.alive && SG.gd(u.x, u.y, me.x, me.y) < SEE_R && (u.sentry == null || Math.sign(me.x - u.x) === u.look));
        V.alert = Math.max(0, V.alert + (seen ? SEEN * dt : -3 * dt));
        for (const u of V.watch) if (!u.alive && !u.missed) { u.missed = true; V.alert += 10; m.line('山越', '咦，阿三呢？'); }
        V.alertMax = Math.max(V.alertMax, V.alert);
        m.get('alert').text = `賊的警覺：${Math.min(100, Math.round(V.alert))}%`;
        if (V.alert >= 100) { m.lose('行蹤敗露，賊眾蜂擁而出'); return false; }
        if (V.planted >= 2) {
          if (!V.drumHint) { V.drumHint = true; m.mark('mouth', MOUTH[0], MOUTH[1], '擂鼓'); m.obj('drum', '回谷口擂鼓（旗鼓越多，賊越怕）'); }
          m.chanAt(me, 'mouth', MOUTH[0], MOUTH[1], 160, 2, '擂鼓', () => { V.go = true; });
        }
        return !!V.go;
      },
    },
    { // 1. 鼓噪而前
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('flags'); m.done('drum'); m.drop('alert'); m.unmark('mouth');
        for (let i = 0; i < 6; i++) m.unmark('s' + i);
        for (const f of V.spots) if (f.up && f.drum) f.beat = true;
        m.big('鼓噪而前！');
        m.card('夜潛山谷間，鼓噪而前，應時破散。', '《陸遜傳》');
        V.men = band(m, me, 10, '部曲', WU, { hp: 560, maxHp: 560, atk: 22 });
        // 看到滿山旗幟：旗鼓越多，潰散的越多（親兵與費棧不散）
        const k = V.planted / 6, yue = V.watch.concat(V.zhai).filter((u) => u.alive);
        let n = 0;
        yue.forEach((u, i) => { u.asleep = false; if ((i * 0.618) % 1 < k * 0.92) { n++; } else u.home = [me.x, me.y]; });
        rout(m, w, yue.filter((u, i) => (i * 0.618) % 1 < k * 0.92), [8300, 1000]);
        V.fled = n;
        V.fz.asleep = false; for (const u of V.guard) u.asleep = false;
        m.after(2, () => m.line('山越', n > yue.length / 2 ? '漫山都是旗！官軍大至了！快跑！' : '官軍來了！跟他們拚了！'));
        m.after(4, () => m.line('費棧', '我有曹公印綬，怕什麼！給我殺！'));
        m.mark('fz', V.fz.x, V.fz.y, '費棧', false, V.fz);
        m.obj('fz', '擊破費棧');
      },
      tick(m, w) {
        const V = m.vars;
        if (V.fz.alive) return false;
        return true;
      },
    },
    { // 2. 強者為兵，羸者補戶
      enter(m, w) {
        const V = m.vars;
        m.done('fz'); m.unmark('fz');
        rout(m, w, V.watch.concat(V.zhai, V.guard), [8300, 1000]);
        V.night = false;
        m.big('天亮了');
        m.card('遂部伍東三郡，強者為兵，羸者補戶。', '《陸遜傳》');
        m.after(3, () => m.line('陸遜', '山越的人，壯者編入軍中，羸弱的送到村裡，給田耕種。'));
        m.after(7, () => m.line('提示', '停在俘虜身邊，他就會跟著走（灰衣的是羸弱）。壯丁帶回營裡（西邊），羸弱帶到村裡（西南）。'));
        V.caps = [];
        for (let i = 0; i < STRONG + WEAK; i++) {
          const weak = [1, 4, 6, 9, 11].includes(i), cx = ZHAI[0] - 1500 + (i % 6) * 200, cy = ZHAI[1] - 140 + Math.floor(i / 6) * 230; // 壯丁、羸弱夾雜著蹲在寨前，一個個隔開
          const u = m.recruit(cx, cy, weak ? '山越羸弱' : '山越壯丁');
          u.spec = weak ? LEAN : SHANYUE; u.noFight = true; u.weak = weak; u.home = [u.x, u.y];
          if (weak) { u.hp = u.maxHp = 200; u.r = 15; u.ms = 210; u.size = 0.8; }
          V.caps.push(u);
        }
        V.bing = 0; V.hu = 0;
        m.mark('camp', CAMP[0], CAMP[1], '營：為兵', true);
        m.mark('vill', VILLAGE[0], VILLAGE[1], '村：補戶', true);
        m.mark('caps', ZHAI[0] - 200, ZHAI[1], '俘虜');
        m.obj('sort', '強者為兵，羸者補戶', V.caps.length);
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        for (const u of V.caps) {
          if (!u.alive || u.settled) continue;
          if (!u.owner && SG.gd(u.x, u.y, me.x, me.y) < 110 && m.idle(me)) { m.join(u, me); m.unmark('caps'); m.line(u.name, u.weak ? '小人身子弱，願聽將軍安排……' : '願隨將軍！'); }
          if (!u.owner) continue;
          const at = SG.gd(u.x, u.y, CAMP[0], CAMP[1]) < 420 ? 'bing' : SG.gd(u.x, u.y, VILLAGE[0], VILLAGE[1]) < 420 ? 'hu' : null;
          if (!at) continue;
          u.settled = at; u.owner = null; u.home = at === 'bing' ? [CAMP[0] + 150 - (V.bing % 4) * 60, CAMP[1] + 260 + Math.floor(V.bing / 4) * 60] : [VILLAGE[0] + (V.hu % 4) * 60 - 90, VILLAGE[1] - 200];
          if (at === 'bing') { V.bing++; u.spec = WU; u.name = '精卒'; if (u.weak) { V.wrong++; m.line('軍吏', '這人連矛都提不起來，編進軍中只是吃糧……'); } }
          else { V.hu++; u.name = '民戶'; if (!u.weak) { V.wrong++; m.line('村老', '這麼壯的後生，不去當兵可惜了。'); } }
        }
        const n = V.caps.filter((u) => u.settled || !u.alive).length;
        m.prog('sort', n);
        m.get('sort').text = `強者為兵，羸者補戶（為兵 ${V.bing}、補戶 ${V.hu}）`;
        return n >= V.caps.length;
      },
    },
    { // 3. 所過肅清
      enter(m) {
        m.done('sort'); m.unmark('camp'); m.unmark('vill');
        m.card('得精卒數萬人，宿惡蕩除，所過肅清，還屯蕪湖。', '《陸遜傳》');
        m.after(6, () => m.card('會稽太守淳於式表遜枉取民人，愁擾所在。遜後詣都，言次，稱式佳吏。權曰：「式白君而君薦之，何也？」遜對曰：「式意欲養民，是以白遜。若遜復毀式以亂聖聽，不可長也。」', '《陸遜傳》'));
        m.after(13, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('陸遜陣亡'); return; }
    // 巡山的賊：只巡、只看，不追（被看到就是起疑，滿了才全寨殺出來）
    if (m.i === 0) for (const u of V.watch || []) if (u.alive) { u.target = null; u.think = 0.5; if (u.sentry != null) { u.home = [u.x, u.y]; u.f = u.look || u.f; } }
    // 山寨裡睡著的賊：不吵不動
    for (const u of (V.zhai || []).concat(V.guard || [], V.fz ? [V.fz] : [])) {
      if (!u.alive || !u.asleep) continue;
      if (u.hp < u.maxHp) { u.asleep = false; V.alert += 30; continue; } // 砍醒了：滿寨都會知道
      u.target = null; u.think = 0.5; u.home = [u.x, u.y];
    }
  },
  overlay(ctx, m, view, x0, y0, vw, vh) { if (m.vars.night) night(ctx, x0, y0, vw, vh, 0.5); },
};
